import React, { Suspense } from 'react';
import { Loading } from '@/components/elements';

export const AppContainer = ({ children }: { children: React.ReactNode }) => {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
};

export default AppContainer;
